<template>
    <div class="bg bg--light-blue similar-stock__bg">
        <div class="container similar-stock">
            <h2 class="similar-stock__page-title">Similar vehicles based on your search</h2>

            <div class="similar-stock__slider-nav-group">
                <div class="similar-stock__slider-nav similar-stock__slider-nav--prev">
                    <svg class="similar-stock__slider-nav-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 45" height="45px" width="45px">
                        <path d="M22.5 0C34.926 0 45 10.074 45 22.5S34.926 45 22.5 45 0 34.926 0 22.5 10.074 0 22.5 0Zm0 1.5c-11.598 0-21 9.402-21 21s9.402 21 21 21 21-9.402 21-21-9.402-21-21-21Z"></path>
                        <path d="M24.424 13.52a.75.75 0 1 1 1.152.96l-6.6 7.908 6.6 7.907a.75.75 0 0 1-.016.98l-.08.077a.75.75 0 0 1-1.056-.096l-7-8.388a.75.75 0 0 1 0-.96l7-8.389Z"></path>
                    </svg>
                </div>

                <div class="similar-stock__slider swiper" ref="swiper">
                    <div class="similar-stock__slider-wrapper swiper-wrapper">
                        <div v-for="vehicle in vehicles" class="similar-stock__slider-slide swiper-slide" :key="vehicle.id">
                            <div class="similar-stock__card">
                                <a :href="vehicle.route">
                                    <img v-if="vehicle.used_vehicles_internal_images && typeof vehicle.used_vehicles_internal_images[0] !== 'undefined' && typeof vehicle.used_vehicles_internal_images[0].thumbnail_path !== 'undefined'" loading="lazy" class="img-responsive similar-stock__image" :src="vehicle.used_vehicles_internal_images[0].thumbnail_path" alt="">
                                    <img v-else loading="lazy" class="img-responsive similar-stock__image" srcset="/images/used/image-coming-soon.jpg, /images/used/image-coming-soon@2x.jpg 2x" alt="">
                                </a>

                                <div class="similar-stock__card-inner">
                                    <div class="similar-stock__title-wrapper">
                                        <span class="similar-stock__title"> {{ vehicle.manufacturer }}   {{ vehicle.model }} </span>
                                        <span class="cms-content-slice__trim-name"> {{ vehicle.version }}</span>
                                    </div>

                                    <div class="similar-stock__flex-row similar-stock__flex-row--with-border">
                                        <p>Vehicle Price from:</p><span class="cms-content-price cms-content-price--orange">£{{ vehicle.price_formatted }}</span>
                                    </div>

                                    <a :href="vehicle.route" class="similar-stock__find-out-more link link--has-icon">
                                        Find out more
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="similar-stock__slider-nav similar-stock__slider-nav--next">
                    <svg class="similar-stock__slider-nav-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 45" height="45px" width="45px">
                        <path d="M22.5 0C34.926 0 45 10.074 45 22.5S34.926 45 22.5 45 0 34.926 0 22.5 10.074 0 22.5 0Zm0 1.5c-11.598 0-21 9.402-21 21s9.402 21 21 21 21-9.402 21-21-9.402-21-21-21Z"></path>
                        <path d="M21.576 13.52a.75.75 0 1 0-1.152.96l6.6 7.908-6.6 7.907a.75.75 0 0 0 .016.98l.08.077a.75.75 0 0 0 1.056-.096l7-8.388a.75.75 0 0 0 0-.96l-7-8.389Z"></path>
                    </svg>
                </div>
            </div>

            <div class="similar-stock__view-more">
                <button type="button" @click="navigateToViewMore()" class="btn btn--primary">
                    Discover more
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { customEvent } from '../../../modules/tracking/AnalyticsEvents';
import axios from 'axios';
import Swiper, { Navigation } from 'swiper';
import { MatchHeight } from 'js-match-height';

export default {
    props: {
        vehicle: {
            type: Object,
            required: true
        },
        customEventCategory: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            swiper: null,
            vehicles: [],
        };
    },

    methods: {
        fetchVehicles() {
            axios.get(`/api/used-vehicles/similar-vehicles`, {
                params: {
                    model_type: "RobinsAndDay\\UsedVehicle",
                    id: this.vehicle.id
                }
            }).then(response => {
                    this.vehicles = response.data;
                    this.initSwiper();
                }).catch(error => {
                    console.error(error);
                });
        },

        initSwiper() {
            this.$nextTick().then(() => {
                this.swiper = new Swiper(this.$refs.swiper, {
                    modules: [Navigation],
                    grabCursor: true,
                    slidesPerView: 1,
                    spaceBetween: 30,
                    loop: true,
                    navigation: {
                        nextEl: '.similar-stock__slider-nav--next',
                        prevEl: '.similar-stock__slider-nav--prev',
                    },
                    breakpoints: {
                        576: {
                            slidesPerView: 2,
                        },
                        768: {
                            slidesPerView: 3,
                        },
                    }
                })

                this.matchHeight();
            })
        },

        matchHeight() {
            new MatchHeight('.similar-stock__card-inner');
        },

        navigateToViewMore() {
            customEvent({
                category: this.customEventCategory,
                action: 'Clicked',
                label: 'View More Similar Vehicles'
            });

            this.$router.push({
                name: 'used-results',
                params: {
                    resultsType: 'used-vehicles'
                },
                query: {
                    s_id: this.vehicle.id,
                    sortBy: 'related'
                }
            });
        }
    },

    mounted() {
        this.fetchVehicles();
    }
}
</script>

<style lang="scss">
@import "../../../../sass/redesign/variables";
@import "../../../../../../node_modules/vue-slick-carousel/dist/vue-slick-carousel.css";
@import "../../../../../../node_modules/vue-slick-carousel/dist/vue-slick-carousel-theme.css";

.similar-stock {
    // margin-top: 30px;
    // margin-bottom: 30px;

    // &__bg {
    //     margin-bottom: -45px;
    // }

    &__page-title {
        font-size: 18px;
        font-weight: 700;
        margin: 0;
        text-align: center;

        @media (min-width: $screen-md) {
            text-align: left;
        }
    }

    &__slider {
        margin-top: 16px;
    }

    &__slider-slide {
        margin-bottom: 20px;
    }

    &__card {
        box-shadow: $default-card-box-shadow;
        border-radius: $default-card-border-radius;
        background-color: white;
        overflow: hidden;
    }

    &__card-inner {
        display: flex;
        flex-direction: column;
        gap: 5px;
        padding: 28px 30px;
    }

    &__image {
        width: 100%;
        object-fit: contain;
        aspect-ratio: 91/51;
        object-position: center;
    }

    &__title-wrapper {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
    }

    &__title {
        font-size: 20px;
        font-weight: 700;
        margin: 0;
    }

    &__slider-nav-group {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 15px;
    }

    &__flex-row {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        margin-top: 15px;

        &--with-border {
            border-top: 1px solid RGB(151, 151, 151, 0.5);

            &:last-of-type {
                border-bottom: 1px solid RGB(151, 151, 151, 0.5);
            }
        }
    }

    &__find-out-more {
        margin-top: 15px;
        justify-content: center;
    }

    &__slider-nav-svg {
        fill: $blue;
        cursor: pointer;

        &:hover {
            fill: #0279b1;
        }
    }

    &__view-more {
        display: flex;
        justify-content: center;
    }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/used-vue/components/UsedDetails/SimilarStock.vue